import "../css/main.scss";
import "./dynamicScriptsLoader.js";

(async () => {
    await window.loadScript("InteractionScriptsLoader.js");

    if (import.meta.env.CO_SENTRY_ENABLED === "true") {
        window.snakeCheckout.Sentry = await window.loadScript("@sentry/browser");
        window.snakeCheckout.Sentry.init({
            dsn: import.meta.env.CO_SENTRY_DSN,
            environment: import.meta.env.CO_SENTRY_ENV,
            // replaysOnErrorSampleRate: 0.2,
            // normalizeDepth: 6,
            sendDefaultPii: true,
            integrations: [
                window.snakeCheckout.Sentry.httpClientIntegration(),
                window.snakeCheckout.Sentry.extraErrorDataIntegration(),
                // Sentry.captureConsoleIntegration()
            ],
        });
    }
})();

// FIX "Can't find variable: _AutofillCallbackHandler" - https://developers.facebook.com/community/threads/320013549791141/
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {};

document.addEventListener("DOMContentLoaded", async () => {
    window.snakeCheckout.Storage = await window.loadScript("snake.lib.storage.js");

    const traceEnabled = window.snakeCheckout.Storage.get("debug") === "1" || (import.meta.env.CO_SENTRY_ENV !== "deagostini_production" && import.meta.env.CO_SENTRY_ENV !== "fanhome_production" && import.meta.env.CO_SENTRY_ENV !== "deagostini_production_b" && import.meta.env.CO_SENTRY_ENV !== "fanhome_production_b");
    window.snakeCheckout.Trace = await window.loadScript("snake.lib.trace.js");
    window.snakeCheckout.Trace.enabled = traceEnabled;

    await window.loadScript("checkout.js").then((Checkout) => Checkout.init());
});
